import { useUser } from '@auth0/nextjs-auth0/client';
import { Link } from 'next-translate-routes-multi-domain';
import Trans from 'next-translate/Trans';
import { BsFillInfoCircleFill } from 'react-icons/bs';

function MetadataLink({ children }: { children?: React.ReactNode }) {
  return (
    <Link href='/my/settings'>
      <a className='mr-1 text-blue-500 underline'>{children} </a>
    </Link>
  );
}

export function LinkEditMetadata() {
  const { user } = useUser();
  return !user ? null : (
    <div className='flex items-center space-x-2'>
      <BsFillInfoCircleFill className='text-blue-500' />
      <div className=''>
        <Trans
          i18nKey='products:DATA_FULLFILLED_AUTO_EDIT_ACCOUT_DATA_HERE'
          components={{
            link: <MetadataLink />,
          }}
        />
      </div>
    </div>
  );
}
